import { render } from "./WebhooksFiltersEditorVisualBig.vue?vue&type=template&id=152af640&ts=true"
import script from "./WebhooksFiltersEditorVisualBig.vue?vue&type=script&lang=ts"
export * from "./WebhooksFiltersEditorVisualBig.vue?vue&type=script&lang=ts"

import "./WebhooksFiltersEditorVisualBig.vue?vue&type=style&index=0&id=152af640&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__